import React from 'react';
import { Modal } from 'antd';

const CustomModal = ({ isVisible, setIsVisible, children , title,width, footer , cb}) => {
  return (
    <Modal
      width={width||"50%"}
      title={title}
      visible={isVisible}
      onCancel={() => {
        setIsVisible(false)
        cb && cb()
      }}
      footer={footer ? footer :null} // You can customize footer or add buttons here
      onOk={() => {
        setIsVisible(false)
       
      
      }} // Closes modal on OK button click
    >
      {children}
    </Modal>
  );
};

export default CustomModal;



// WEBPACK FOOTER //
// ./src/Common-Modal/CustomModal.js